module.exports = __webpack_public_path__ + "static/media/header-mobile.585a00e6.png";